import React from 'react';
import { styled } from '@mui/material';

import { Button, Container, Icon, IconButton, Stack, Tabs, Text, TextInput, Tooltip } from 'shell/components';

const Tablet = ({
    course,
    coursePercentage,
    setIsFilterDrawerOpen,
    tabList,
    defaultRoute,
    setDefaultRoute,
    searchBarInput,
    onChangeSearchBarInput,
}) => {
    return (
        <Container device={'tablet'}>
            <CustomStack spacing={4}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Stack>
                        <Text variant={'h6'} weight={'semibold'}>
                            {course.name}
                        </Text>
                        <Stack alignItems={'center'} direction={'row'} spacing={4}>
                            <Text variant={'p2'}>Classes’ Completion Average - {coursePercentage}%</Text>
                            <Tooltip
                                content={
                                    <Stack spacing={4}>
                                        <Text color={'inherit'} variant={'p2'}>
                                            Each team’s status is determined by comparing their{' '}
                                            <Text
                                                color={'inherit'}
                                                component={'span'}
                                                variant={'p2'}
                                                weight={'semibold'}
                                            >
                                                project completion percentage
                                            </Text>{' '}
                                            to the{' '}
                                            <Text
                                                color={'inherit'}
                                                component={'span'}
                                                variant={'p2'}
                                                weight={'semibold'}
                                            >
                                                completion average
                                            </Text>{' '}
                                            of the class.
                                        </Text>
                                        <Text color={'inherit'} variant={'p2'}>
                                            Teams with a completion percentage that is equivalent to or above the
                                            average will be marked as{' '}
                                            <Text
                                                color={'inherit'}
                                                component={'span'}
                                                variant={'p2'}
                                                weight={'semibold'}
                                            >
                                                On Track
                                            </Text>
                                            , teams slightly below the average will be marked as{' '}
                                            <Text
                                                color={'inherit'}
                                                component={'span'}
                                                variant={'p2'}
                                                weight={'semibold'}
                                            >
                                                Caution
                                            </Text>
                                            , and teams significantly below the average will be marked as{' '}
                                            <Text
                                                color={'inherit'}
                                                component={'span'}
                                                variant={'p2'}
                                                weight={'semibold'}
                                            >
                                                Off Track
                                            </Text>
                                            .
                                        </Text>
                                    </Stack>
                                }
                                type={'info'}
                            />
                        </Stack>
                    </Stack>
                    <Stack alignItems={'center'} direction={'row'} spacing={3}>
                        <Button
                            color={'neutral'}
                            startIcon={<Icon kind={'filter'} />}
                            variant={'tertiary'}
                            onClick={() => setIsFilterDrawerOpen(true)}
                        >
                            Filters
                        </Button>
                        <CustomTextInput
                            disablePointerEventsOnIcon={!Boolean(searchBarInput)}
                            endIcon={
                                searchBarInput ? (
                                    <IconButton
                                        aria-label={'clear search input'}
                                        kind={'exit'}
                                        variant={'square'}
                                        onClick={() => onChangeSearchBarInput('')}
                                        onMouseDown={(e) => e.preventDefault()}
                                    />
                                ) : (
                                    <Icon kind={'search'} />
                                )
                            }
                            placeholder={'Search'}
                            value={searchBarInput}
                            onChange={(e) => onChangeSearchBarInput(e.target.value)}
                        />
                    </Stack>
                </Stack>
                <Tabs
                    aria-label={'select teams to view'}
                    options={tabList}
                    selected={defaultRoute}
                    onChange={setDefaultRoute}
                />
            </CustomStack>
        </Container>
    );
};

const CustomStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CustomTextInput = styled(TextInput)(() => {
    return {
        width: '13.5rem',
    };
});

export default Tablet;
